<!--Payment Success-->
<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row my-0 mx-0">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img *ngIf="!paymentResult?.timeout" class="payment-result-logo" [src]="'assets/images/png/payment-success.png'" [srcset]="'assets/images/png/payment-success@2x.png 2x, assets/images/png/payment-success@3x.png 3x'"
           alt="logo">
      <img *ngIf="paymentResult?.timeout" class="payment-result-logo" [src]="'assets/images/png/timeout.png'" [srcset]="'assets/images/png/timeout@2x.png 2x, assets/images/png/timeout@3x.png 3x'"
           alt="logo">
    </div>
    <div class="col-12 px-0 d-flex justify-content-center"><label
      class="payment-result-header">{{paymentResult?.timeout ? "İşleminiz Zaman Aşımına Uğradı" : paymentResult?.message}}</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="payment-result-info" *ngIf="!paymentResult?.timeout">
        <p
          *ngIf="paymentResult?.paymentStatusModel?.paymentResult?.amount">{{this.textService.keyValueMapping('successPageTotalAmountLabel', 'Toplam Tutar:', sdkInitTexts)}}
          <span class="">₺{{paymentResult?.paymentStatusModel?.paymentResult?.amount / 100 | amount}}</span></p>
        <p
          *ngIf="paymentResult?.paymentStatusModel?.paymentResult?.paymentMethod?.paymentMethodType">{{this.textService.keyValueMapping('successPagePaymentMethodLabel', 'Ödeme Yöntemi:', sdkInitTexts)}}
          <span
            class="">{{determinePaymentType(paymentResult?.paymentStatusModel?.paymentResult?.paymentMethod)}}</span>
        </p>
        <!--        <p>Kazanılan Paycell Puan: <span class="">630</span></p>-->
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center"><label *ngIf="!paymentResult?.timeout"
                                                                  class="payment-result-message">
      {{this.textService.keyValueMapping('successPageDescription', 'İşlem geçmişi ve puan bilgilerinize Paycell mobil uygulamasından ulaşabilirsiniz.', sdkInitTexts)}}
    </label>
      <label *ngIf="paymentResult?.timeout"
             class="payment-timeout-message">
        {{paymentResult?.message}}
      </label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <pa-redirect></pa-redirect>
    </div>
  </div>
</div>
<!--Payment Error-->
<!--<div class="container-fluid px-0" *ngIf="paymentResult?.paymentStatusModel?.status !== 'SUCCESS'">-->
<!--  <div class="row my-0 mx-0">-->
<!--    <div class="col-12 px-0 d-flex justify-content-center">-->
<!--      <img class="payment-result-logo" [src]="'assets/images/png/payment-error.png'" alt="logo"></div>-->
<!--    <div class="col-12 px-0 d-flex justify-content-center"><label class="payment-result-error-header">Ödeme-->
<!--      Başarısız!</label>-->
<!--    </div>-->
<!--    <div class="col-12 px-0 d-flex justify-content-center"><label class="payment-result-error-message">Lorem ipsum dolor-->
<!--      sit amet, consectetur adipisicing elit, sed do eiusmod tempor</label></div>-->
<!--    <div class="col-12 px-0 d-flex justify-content-center">-->
<!--      <div class="path"></div>-->
<!--    </div>-->
<!--    <div class="col-12 px-0 d-flex justify-content-center">-->
<!--      <pa-redirect></pa-redirect>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
